// rename Object.freeze to be more explizit
export const freezeToStopVueReactivity = Object.freeze;
